// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ElementController from "./element_controller"
application.register("element", ElementController)

import { Datepicker } from './no_animation_stimulus_datepicker'
application.register('datepicker', Datepicker)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SelectSubmitController from "./select_submit_controller"
application.register("select-submit", SelectSubmitController)

import SelectTabController from "./select_tab_controller"
application.register("select-tab", SelectTabController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import ModalActionLinkController from "./modal_action_link_controller"
application.register("modal-action-link", ModalActionLinkController)

import CustomerSettingController from "./customer_setting_controller"
application.register("customer-setting", CustomerSettingController)